import {BaseFormModel} from './base-form-model';
import {MenuModifierSelection} from './menu-modifier-selection';
import {MenuToppingModifierSelectionOption} from './menu-topping-modifier-selection-option';

export class MenuToppingModifierSelection extends BaseFormModel<MenuToppingModifierSelection> {
    id: number;
    menuModifierSelection: MenuModifierSelection;
    sortOrder: number;
    options: MenuToppingModifierSelectionOption[];
}
